const { reduce, some } = require('lodash');

class FormValidationSummaryController {
    constructor($scope, $element, moveFocus) {
        this.$element = $element;
        this.moveFocus = moveFocus;
        $scope.$on('$submitted', () => {
            moveFocus($element.find('._errorMessage'));
        });
    }

    $onInit() {
        // We need to track the form's prototype so that we can check if a field in error
        // is actually a whole nested form
        this.formPrototype = Object.getPrototypeOf(this.form).constructor;
    }

    hasValidationErrors() {
        return this.form.$submitted && some(this.form.$error);
    }

    getErrorCountForForm(form) {
        return reduce(form.$error, (acc, errors) =>
            acc + reduce(errors, (acc2, invalidElement) =>
                acc2 + (invalidElement instanceof this.formPrototype
                    ? this.getErrorCountForForm(invalidElement)
                    : 1),
            0),
        0);
    }

    errorCount() {
        return this.getErrorCountForForm(this.form);
    }

    setFocusOnFirstError() {
        this.moveFocus(
            this.$element.parent(`[name=${this.form.$name}]`).find('input.ng-invalid').first(),
        );
    }
}

FormValidationSummaryController.$inject = ['$scope', '$element', 'MoveFocus'];

const formValidationSummaryComponentDefinition = {
    controller: FormValidationSummaryController,
    bindings: {
        userMessage: '@?',
        serverErrorMessage: '@?',
    },
    require: {
        form: '^form',
    },
    template: require('./form-validation-summary.component.html').trim(),
};

module.exports = {
    FormValidationSummaryController,
    formValidationSummaryComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/form-validation-summary/form-validation-summary.component.js